export default __webpack_public_path__ + "static/media/IncentivePaymentReport.237974ce.svg";